var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"}},[_c('path',{attrs:{"d":"M13 6.5L8 11.5L3 6.5","stroke":"currentColor","stroke-width":"1.2","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }